import { buildResult, skip } from "../../buildResult";
import { defineTest } from "../../defineTest";
import { resolveTrace } from "../../helper/trace";

export default defineTest(
  "trace_patient_id_match",
  "Trace patient ID match",
  ({ patient, trace, fetchErrors }) => {
    const resolved = resolveTrace({ trace, fetchErrors });
    if (!resolved.ok) return resolved.result;

    const { events } = resolved;
    if (events.length === 0) return skip("Trace has no events");

    const patientIdStr = patient?.patient_id != null ? String(patient.patient_id) : "";
    if (!patientIdStr) return skip("No patient_id on record");

    const foreignPatientEvents = events.filter(
      (e) => e.patient_id != null && String(e.patient_id) !== patientIdStr
    );

    if (foreignPatientEvents.length > 0) {
      return buildResult({
        warnings: [
          `${foreignPatientEvents.length} trace event(s) reference a different patient_id`,
        ],
      });
    }

    return buildResult({ successes: ["All trace events match this patient_id"] });
  }
);
